"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blOrderEligibilityExplainQuerySchema = exports.blOrderEligibilityQuerySchema = exports.evaluateEligibilitySchema = exports.eligibilityBlOrderIdSchema = exports.EVALUATE_BATCH_MAX = void 0;
const zod_1 = require("zod");
const financing_1 = require("../financing");
exports.EVALUATE_BATCH_MAX = 500;
// JS BigInt has arbitrary precision. A value above the Postgres bigint maximum causes a 500 error instead of a 400.
const PG_BIGINT_MAX = 9223372036854775807n;
// documents/bl-order-id.ts already defines blOrderIdSchema with only the regex check. This schema adds the bigint range check.
exports.eligibilityBlOrderIdSchema = zod_1.z
    .string()
    .regex(/^\d+$/, 'BL order id must be a decimal string')
    // Zod v3 runs every refinement even after a failed check, so the regex repeats here. Otherwise BigInt would throw on bad input.
    .refine((id) => !/^\d+$/.test(id) || BigInt(id) <= PG_BIGINT_MAX, {
    message: 'BL order id is outside the Postgres bigint range',
});
exports.evaluateEligibilitySchema = zod_1.z
    .object({
    partners: financing_1.financingPartnerSchema.array().min(1).optional(),
    // The cap applies only to the deduplicated array. Zod v3's .max() checks before the transform runs, so superRefine checks after.
    bl_order_ids: zod_1.z
        .array(exports.eligibilityBlOrderIdSchema)
        .transform((ids) => Array.from(new Set(ids)))
        .superRefine((ids, ctx) => {
        if (ids.length > exports.EVALUATE_BATCH_MAX) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.too_big,
                maximum: exports.EVALUATE_BATCH_MAX,
                type: 'array',
                inclusive: true,
                message: `bl_order_ids must contain at most ${String(exports.EVALUATE_BATCH_MAX)} unique ids`,
            });
        }
    })
        .optional(),
})
    // A body with as_of, or any other unknown key, is rejected. The request wire never carries a clock value.
    .strict();
// This schema is not strict. Rejecting a stray query parameter, such as a cache-buster, would be too strict for a GET request.
exports.blOrderEligibilityQuerySchema = zod_1.z.object({
    partner: financing_1.financingPartnerSchema.optional(),
});
// partner is required here. A trace across every partner is too large to be useful.
exports.blOrderEligibilityExplainQuerySchema = zod_1.z.object({
    partner: financing_1.financingPartnerSchema,
});
//# sourceMappingURL=eligibility.js.map